import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoginObserverService implements OnInit {

    loginObserverSubject: Subject<void> = new Subject<void>();
    /**
    * Subscribe to events regarding login events.
    */
    public loginObserver = this.loginObserverSubject.asObservable();

    logoutObserverSubject: Subject<boolean> = new Subject<boolean>();
    /**
    * Subscribe to events regarding logout events.
    */
    public logoutObserver = this.logoutObserverSubject.asObservable();

    accessForbiddenObserverSubject: Subject<HttpErrorResponse> = new Subject<HttpErrorResponse>();
    /**
    * Subscribe to events regarding access forbidden.
    */
    public accessForbiddenObserver = this.accessForbiddenObserverSubject.asObservable();

    azureLoginRequiredObserverSubject: Subject<void> = new Subject<void>();
    /**
    * Subscribe to events regarding azure login.
    */
    public azureLoginRequiredObserver = this.azureLoginRequiredObserverSubject.asObservable();

    azureLoginInsufficientPermissionsSubject: Subject<void> = new Subject<void>();
    /**
    * Subscribe to events regarding azure login permissions.
    */
    public azureLoginInsufficientPermissionsObserver = this.azureLoginInsufficientPermissionsSubject.asObservable();

    constructor() {
    }

    ngOnInit() {

    }

    /**
     * Call this method to notify listeners that a user has been logged in.
     */
    userLogIn() {
        this.loginObserverSubject.next();
    }

    /**
     * Call this method to notify listeners that a user has been logged out.
     */
    userLogOut(triggeredByUser = false) {
        this.logoutObserverSubject.next(triggeredByUser);
    }

    /**
     * Call this method to notify listeners that the user ran into an "access forbidden" .
     */
    notifyAccessForbidden(error: HttpErrorResponse) {
        this.accessForbiddenObserverSubject.next(error);
    }

    /**
     * Call this method to require new Azure AD login .
     */
     requireAzureAdLogin() {
        this.azureLoginRequiredObserverSubject.next();
    }

    /**
     * Call this method to notify listeners that the user has insufficient permissions to login.
     */
     notifyInsufficientLoginPermisssions() {
        this.azureLoginInsufficientPermissionsSubject.next();
    }
}
